@import 'styles/mixins';
@import 'styles/variables';

/** Following rule was disabled in order to facilitate introduction of eslint to the codebase (in other words, I didn't
want to bother fixing it) and not on purpose. If you know anything about this code, please fix */
/* stylelint-disable css-modules/no-global-scoped-selector */
mark[data-type='todo'] {
  // Neutralise styles applied from the schema directly to the mark
  background-color: inherit !important;
  border-bottom: 0;

  &[data-resolved='false'] {
    .show {
      background-color: #ecf9ff !important;
      border-bottom: 1px solid $blue-10;

      &.highlighted {
        background-color: #def4ff !important;
        border-bottom-color: $blue-20;
      }

      &.active {
        background-color: $blue-20;
        border-bottom-color: $blue-20;
      }
    }
  }

  // Disable the styles for the case where a gradient is inside a todo. We instead use a custom decoration to handle this case.
  > span[data-color*='linear-gradient'] {
    background: unset !important;
    background-clip: unset !important;
    -webkit-background-clip: unset !important;
    -moz-background-clip: unset !important;
    -webkit-text-fill-color: unset !important;
    -moz-text-fill-color: unset !important;
  }
}

a mark[data-type='todo'] {
  &[data-resolved='false'] {
    -webkit-text-fill-color: unset;
    -moz-text-fill-color: unset;
  }
}
/* stylelint-enable css-modules/no-global-scoped-selector */
